<template>
  <div class="space-y-20px section-text">
    <Title
      v-if="title"
      :headingTag="headingTag"
      :style="headingTag"
      bottomSpacing>
      <slot name="title">{{ title }}</slot>
    </Title>
    <Paragraphs v-if="highlightText" isHighlight v-html="highlightText" />
    <Paragraphs :listStyle="listStyle" v-html="body" />
    <p class="space-x-2" v-if="buttons" :class="btnAlign(buttons)">
      <Button
        v-for="(button, key) in buttons"
        :key="key"
        :tag="button.buttonType"
        :style="button.buttonStyle"
        :link="button.url"
        @btn-click="onClick"
        >{{ button.buttonText }}</Button
      >
    </p>
    <Footnotes v-if="footnotes" :footnotes="footnotes" />
  </div>
</template>

<script>
import Button from "../Atoms/Button.vue";
import Footnotes from "../Atoms/Footnotes.vue";
import Paragraphs from "../Atoms/ParagraphsNew.vue";
import Title from "../Atoms/Heading.vue";

import useHasSlot from "../../compostables/useHasSlot";
import {
  useIsHeaderTag,
  useCustomValidator,
} from "../../compostables/useValidators";

import { computed } from "vue";

export default {
  components: {
    Button,
    Footnotes,
    Paragraphs,
    Title,
  },

  props: {
    listStyle: {
      type: String,
      required: false,
      validator(value) {
        return useCustomValidator(["arrow"], value);
      },
    },
    body: {
      type: String,
      required: true,
    },
    buttons: {
      type: Object,
      required: false,
    },
    highlightText: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    headingTag: {
      type: String,
      required: false,
      default: "h2",
      validator(value) {
        return useIsHeaderTag(value);
      },
    },
    footnotes: {
      type: Array,
      required: false,
    },
  },

  emits: ["btn-click"],

  setup(props, { emit, slots }) {
    const { hasSlot } = useHasSlot(slots);

    const btnAlign = (buttons) => {
      if (
        buttons.length &&
        buttons.some((obj) => obj.hasOwnProperty("buttonAlignment"))
      ) {
        const alignment = buttons[0].buttonAlignment;
        switch (alignment) {
          case "left":
            return "text-left";
            break;

          case "right":
            return "text-right";
            break;

          default:
            return "text-center";
            break;
        }
      }

      return false;
    };

    const onClick = (...args) => {
      // Bubble up all arguments
      emit("btn-click", ...args);
    };

    return {
      hasSlot,
      btnAlign,
      onClick,
    };
  },
};
</script>

<style></style>
